module.exports = "edit_circle_pencil"